import API from 'util/API';

export const getFoodcourts = async () => {
  const response = await API.get('/foodcourts');
  return response.data;
};

export const getFoodcourt = async (foodcourtId) => {
  const response = await API.get(`/foodcourts/${foodcourtId}`);
  return response.data;
};

export const createFoodcourt = async (data) => {
  const response = await API.post('/foodcourts', data);
  return response.data;
};

export const updateFoodcourt = async ({ foodcourtId, ...data }) => {
  const response = await API.put(`/foodcourts/${foodcourtId}`, data);
  return response.data;
};

export const deleteFoodcourt = async (foodcourtId) => {
  const response = await API.delete(`/foodcourts/${foodcourtId}`);
  return response.data;
};

export const uploadFoodcourtImage = async ({ foodcourtId, formData }) => {
  const response = await API.post(`/foodcourts/${foodcourtId}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
